import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { userApiClient } from '../userApiClient';

/** True when the signed-in user has at least one tutor booking (any status). */
export function useHasUserTutorBookings(enabled: boolean): boolean {
  const location = useLocation();
  const [hasBookings, setHasBookings] = useState(false);

  const refresh = useCallback(async () => {
    if (!enabled) {
      setHasBookings(false);
      return;
    }

    try {
      const summary = await userApiClient.getTutorBookingsSummary();
      setHasBookings((summary.all ?? 0) > 0);
    } catch {
      // Nav visibility is non-critical; keep the last known value on transient errors.
    }
  }, [enabled]);

  useEffect(() => {
    void refresh();
  }, [refresh, location.pathname]);

  return hasBookings;
}
